import OrbitApiV1 from '.'

class BundleAPI {
  static getbundleProducts(orgId) {
    return OrbitApiV1.httpGet(`/bundles/getByOrgId/${orgId}`)
  }
}

export default BundleAPI
